/**
 * 根据文件类型交换出 input 标签合适的 accept 属性
 * @param {array} types 文件类型数组
 */
export const reduceFileAccept = types => {
  return types.reduce((accumulator, item, index) => {
    const separator = index > 0 ? ',' : ''
    item = item.toLowerCase()
    return `${accumulator}${separator}.${item}`
  }, '')
}

export {
  removeFileExtension,
  isMp3,
  isMp4,
  isImage
} from '@com/utils/file'
